var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart"},[_c('v-badge',{staticClass:"badge",attrs:{"color":"pink","content":_vm.$store.state.cart.length,"value":_vm.$store.state.cart.length}},[_c('IconCart',{attrs:{"color":"#00A4B3"},on:{"click":_vm.toggleCart}})],1),(_vm.$store.state.menuActive == 'cart')?_c('Popup',[_c('cart-detail')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }